"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_js_1 = __importDefault(require("currency.js"));
var React = __importStar(require("react"));
var react_1 = require("react");
var react_hook_form_1 = require("react-hook-form");
var store_credit_1 = require("../../../misc/store-credit");
var tooltip_1 = __importDefault(require("../../../plugins/tooltip"));
var format_bundle_variant_title_1 = __importDefault(require("../../../utils/format-bundle-variant-title"));
var format_price_1 = __importDefault(require("../../../utils/format-price"));
var bundle_items_1 = __importDefault(require("../../account-v3/sections/edit-bundle/components/bundle-items"));
var app_1 = require("../app");
var Review = function () {
    var _a, _b, _c;
    var _d = (0, react_1.useContext)(app_1.AppContext), frequency = _d.frequency, minSelectionTotal = _d.minSelectionTotal, selectedChoices = _d.selectedChoices, shippingIntervalFrequencies = _d.shippingIntervalFrequencies, subTotalBundlePrice = _d.subTotalBundlePrice, totalNumChoices = _d.totalNumChoices, totalBundlePrice = _d.totalBundlePrice, setFrequency = _d.setFrequency, setLeftSideImage = _d.setLeftSideImage, existingCustomerNewBundleDiscount = _d.existingCustomerNewBundleDiscount, existingCustomerNewBundleSavings = _d.existingCustomerNewBundleSavings, filteredPromotionalAddOns = _d.filteredPromotionalAddOns;
    (0, react_1.useEffect)(function () {
        var _a;
        setLeftSideImage((_a = window.essentialsBundlerApp) === null || _a === void 0 ? void 0 : _a.settings.review.leftSideImage);
    }, []);
    if (!minSelectionTotal || totalNumChoices < minSelectionTotal) {
        // kick-back to first step if no products are selected
        window.location.href = '/collections/fundamentals-bundle';
    }
    var renderItemImage = function (item) {
        var _a;
        return (React.createElement(bundle_items_1.default, { items: [
                {
                    title: (0, format_bundle_variant_title_1.default)(item.product ? item.product.title : item.variant.title),
                    quantity: item.quantity,
                    isOOS: false,
                    isLowStock: false,
                    imgSrc: ((_a = item.variant.featured_image) === null || _a === void 0 ? void 0 : _a.src) || item.product.featured_image,
                },
            ], supressLowStockMessage: true }));
    };
    var renderLineItem = function (item) {
        return (React.createElement("div", { className: 'padding-vertical-3 text-gray', key: item.variant.id },
            React.createElement("div", { className: 'grid-x' },
                React.createElement("div", { className: 'small-6' }, renderItemImage(item)),
                React.createElement("div", { className: 'small-6 text-right' },
                    item.variant.compare_at_price && React.createElement("span", { style: { paddingRight: '5px', textDecoration: 'line-through' } }, (0, format_price_1.default)(item.variant.compare_at_price)),
                    React.createElement("span", { className: 'text-wisteria' }, (0, format_price_1.default)(item.variant.price)),
                    item.quantity > 1 && React.createElement("div", { className: 'h7' }, "each")))));
    };
    var _e = (0, react_hook_form_1.useForm)({
        mode: 'all',
        defaultValues: {
            frequency: frequency,
        },
    }), register = _e.register, watch = _e.watch;
    var selectedFrequency = watch('frequency');
    (0, react_1.useEffect)(function () {
        setFrequency(selectedFrequency);
    }, [selectedFrequency]);
    var weekOptions = shippingIntervalFrequencies === null || shippingIntervalFrequencies === void 0 ? void 0 : shippingIntervalFrequencies.map(function (frequencyString) { return Number(frequencyString); });
    var subTotal = (0, format_price_1.default)(subTotalBundlePrice);
    var totalBundleSavings = (0, format_price_1.default)(subTotalBundlePrice - totalBundlePrice);
    var isLoggedIn = !!((_a = window.customer) === null || _a === void 0 ? void 0 : _a.id);
    var customerCreditAccountQuery = (0, store_credit_1.useCustomerCreditAccount)({ enabled: !!isLoggedIn });
    var customerStoreCreditBalance = ((_c = (_b = customerCreditAccountQuery.data) === null || _b === void 0 ? void 0 : _b.account.creditAccount) === null || _c === void 0 ? void 0 : _c.available_balance)
        ? Number(customerCreditAccountQuery.data.account.creditAccount.available_balance)
        : 0;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'padding-horizontal-4 padding-vertical-3 medium-padding-horizontal-6 medium-padding-vertical-4' },
            selectedChoices.map(renderLineItem), filteredPromotionalAddOns === null || filteredPromotionalAddOns === void 0 ? void 0 :
            filteredPromotionalAddOns.map(function (product, i) {
                var variant = product.variants[0];
                var freeConditions = /\((.*?)\)/.exec(product.title);
                return (React.createElement("div", { className: 'padding-vertical-5', key: i },
                    React.createElement("div", { className: 'display-inline font-bold' },
                        "1 x ",
                        product.title.split('(')[0],
                        " ",
                        React.createElement("span", { className: 'text-wisteria' },
                            "(",
                            freeConditions ? freeConditions[1] : '',
                            ")")),
                    variant.compare_at_price && React.createElement("span", { className: 'strike text-gray padding-left-2' }, (0, format_price_1.default)(variant.compare_at_price)),
                    React.createElement("span", { className: 'padding-left-2' },
                        "+",
                        (0, format_price_1.default)(variant.price))));
            }),
            React.createElement("div", { className: 'padding-vertical-5' }, "Bundle Frequency"),
            React.createElement("label", null,
                React.createElement("select", { name: 'frequency', ref: register() }, weekOptions === null || weekOptions === void 0 ? void 0 : weekOptions.map(function (num) { return (React.createElement("option", { key: num, value: num },
                    num,
                    " weeks")); }))),
            React.createElement("div", { className: 'grid-x padding-top-5' },
                React.createElement("div", { className: 'small-6' }, "Subtotal"),
                React.createElement("div", { className: 'small-6 text-right' }, subTotal),
                React.createElement("div", { className: 'small-6' }, "Total bundle savings"),
                React.createElement("div", { className: 'small-6 text-right text-wisteria' },
                    "-",
                    totalBundleSavings),
                existingCustomerNewBundleSavings && existingCustomerNewBundleDiscount && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'small-6' },
                        "Discount savings ",
                        existingCustomerNewBundleDiscount.discount_type === 'percentage' && "".concat(existingCustomerNewBundleDiscount.value, "%")),
                    React.createElement("div", { className: 'small-6 text-right text-wisteria' },
                        "-",
                        (0, format_price_1.default)(existingCustomerNewBundleSavings))))),
            React.createElement("div", { className: 'text-nobel font-italic float-right font-size-small padding-top-5' }, "(Plus applicable tax and shipping)")),
        React.createElement("div", { className: 'padding-horizontal-4 medium-padding-horizontal-6 padding-vertical-15 text-center font-size-small' },
            customerStoreCreditBalance > 0 && (React.createElement("div", null,
                "Your Store Credit will automatically apply.",
                React.createElement(tooltip_1.default, { button: React.createElement("i", { className: 'ss-info padding-left-1 font-size-small', style: { verticalAlign: 'middle', lineHeight: '100%' } }) },
                    React.createElement("div", { className: 'padding-3 font-size-small' },
                        "You have ",
                        React.createElement("span", { className: 'font-bold' },
                            "$",
                            (0, currency_js_1.default)(customerStoreCreditBalance).toString()),
                        " in Store Credit available.")))),
            React.createElement("div", null,
                "Your Bundle will ship every ",
                selectedFrequency,
                " weeks. Cancel online anytime."))));
};
exports.default = Review;
